export interface WorkflowConfig {
  enabled: boolean;
  workflowEngineUrl: string;
  eventProcessing: {
    enableDatabaseEvents: boolean;
    enableWebhookEvents: boolean;
    enableTimerEvents: boolean;
    enableManualEvents: boolean;
  };
  temporal: {
    namespace: string;
    maxConcurrentWorkflows: number;
    workflowTimeout: number;
  };
  performance: {
    eventBufferSize: number;
    processingConcurrency: number;
    retryAttempts: number;
  };
  tenant: {
    organizationId: string;
    enableTenantIsolation: boolean;
  };
}

export interface WorkflowConfigForm {
  // General Settings
  enabled: boolean;
  workflowEngineUrl: string;

  // Event Processing
  enableDatabaseEvents: boolean;
  enableWebhookEvents: boolean;
  enableTimerEvents: boolean;
  enableManualEvents: boolean;

  // Temporal.io Settings
  temporalNamespace: string;
  maxConcurrentWorkflows: number;
  workflowTimeout: number; // in seconds

  // Performance
  eventBufferSize: number;
  processingConcurrency: number;
  retryAttempts: number;

  // Multi-tenant
  organizationId: string;
  enableTenantIsolation: boolean;
}

export const defaultWorkflowConfig: WorkflowConfigForm = {
  enabled: true,
  workflowEngineUrl: import.meta.env.VITE_WORKFLOW_BACKEND_URL || '/workflow-api',

  // Event Processing - all enabled by default
  enableDatabaseEvents: true,
  enableWebhookEvents: true,
  enableTimerEvents: true,
  enableManualEvents: true,

  // Temporal.io defaults
  temporalNamespace: 'terramatrix-workflows',
  maxConcurrentWorkflows: 100,
  workflowTimeout: 3600, // 1 hour

  // Performance defaults
  eventBufferSize: 1000,
  processingConcurrency: 10,
  retryAttempts: 3,

  // Multi-tenant
  organizationId: '',
  enableTenantIsolation: true,
};

export const workflowTimeoutOptions = [
  { value: 300, label: '5 minutes' },
  { value: 900, label: '15 minutes' },
  { value: 1800, label: '30 minutes' },
  { value: 3600, label: '1 hour' },
  { value: 7200, label: '2 hours' },
  { value: 14400, label: '4 hours' },
  { value: 28800, label: '8 hours' },
  { value: 86400, label: '24 hours' },
];

export const eventSourceOptions = [
  {
    id: 'database',
    label: 'Database Events',
    description: 'Monitor MongoDB change streams for data modifications'
  },
  {
    id: 'webhook',
    label: 'Webhook Events',
    description: 'Receive events from external systems via HTTP webhooks'
  },
  {
    id: 'timer',
    label: 'Timer Events',
    description: 'Schedule recurring or time-based workflow triggers'
  },
  {
    id: 'manual',
    label: 'Manual Events',
    description: 'User-initiated workflow executions'
  },
];
